// Client-side result exports (CSV + printable PDF). No financial data ever leaves the browser.

export function downloadCSV(filename, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => {
          const s = String(cell ?? "");
          return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(",")
    )
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  triggerDownload(blob, filename.endsWith(".csv") ? filename : `${filename}.csv`);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Lightweight printable PDF via a new window using the browser's print-to-PDF.
export function printResultPDF({ title, subtitle, sections }) {
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  const css = `
      * { font-family: 'Manrope', -apple-system, sans-serif; color: #1A202C; }
      body { padding: 40px; }
      h1 { font-size: 24px; margin: 0 0 4px; color: #0F4C3A; }
      .sub { color: #718096; margin-bottom: 24px; font-size: 13px; }
      .section { margin-bottom: 24px; }
      .section h2 { font-size: 15px; text-transform: uppercase; letter-spacing: .06em; color: #4A5568; border-bottom: 1px solid #E2E8F0; padding-bottom: 6px; }
      table { width: 100%; border-collapse: collapse; font-size: 13px; }
      td { padding: 6px 4px; border-bottom: 1px solid #F0F2F1; }
      td:last-child { text-align: right; font-weight: 600; }
      .foot { margin-top: 40px; font-size: 11px; color: #A0AEC0; }`;
  const doc = w.document;
  doc.title = title || "MyFinancesGuru Tools";

  // Static resources built as elements (no HTML string injection).
  const fontLink = doc.createElement("link");
  fontLink.rel = "stylesheet";
  fontLink.href = "https://fonts.googleapis.com/css2?family=Manrope:wght@400;600&display=swap";
  const styleEl = doc.createElement("style");
  styleEl.textContent = css;
  doc.head.appendChild(fontLink);
  doc.head.appendChild(styleEl);

  const el = (tag, text, className) => {
    const node = doc.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text); // textContent escapes all dynamic values
    return node;
  };

  doc.body.appendChild(el("h1", title));
  doc.body.appendChild(el("div", subtitle || "", "sub"));

  (sections || []).forEach((s) => {
    const section = el("div", null, "section");
    section.appendChild(el("h2", s.heading));
    const table = doc.createElement("table");
    (s.rows || []).forEach((r) => {
      const tr = doc.createElement("tr");
      tr.appendChild(el("td", r[0]));
      tr.appendChild(el("td", r[1]));
      table.appendChild(tr);
    });
    section.appendChild(table);
    doc.body.appendChild(section);
  });

  doc.body.appendChild(el("div",
    "Generated by MyFinancesGuru Tools — estimates only, not financial advice. Verify figures before making decisions.",
    "foot"));

  setTimeout(() => w.print(), 400);
}
